module.exports = __webpack_public_path__ + "static/media/jack-o-lantern.7188192a.svg";